import { toBrazilianDate } from '../../../../helpers/utils/utils';

/**
 * Mapeamento puro DTO real → shape de UI — espelha
 * `AntecedentesProcessosFactory.makeAntecedentes` (`antecedentesProcessosController.js`,
 * tela real). Fonte: `buscarAntecedentesDoProcessoService` (AW2-1033).
 */
export function mapearAntecedentes(content) {
  return (content || []).map(antecedente => ({
    id: antecedente.idProcesso,
    idFase: antecedente.idFase,
    numero: antecedente.idProcesso,
    acordoAtivo: antecedente.temAcordoAtivo,
    fase: antecedente.nomeFase,
    negociador: antecedente.nomeUsuario,
    dataAbertura: toBrazilianDate(antecedente.dataAbertura),
    cliente: antecedente.nomeCliente,
    devedor: antecedente.nomeDevedor,
    valorProcesso: antecedente.valorTotalCalculado,
  }));
}

function joinIds(ids) {
  const { length } = ids;
  return ids.reduce((acc, id, index) => {
    if (index + 1 === length && length > 1) {
      return `${acc} e ${id}`;
    }
    if (acc) {
      return `${acc}, ${id}`;
    }
    return `${id}`;
  }, '');
}

/**
 * Mensagem de confirmação de Unificar/Juntar — espelha `ShowResumoProcesso.getMessage`
 * (tela real, `antecedentesProcessosController.js`). `ids` deve incluir o
 * `idProcesso` principal junto com os antecedentes selecionados (mesmo shape
 * que a tela real monta em `screenEnabledStatus.idsSelected`) — o processo
 * "destino" (`oldIdProcesso`) é o menor id entre TODOS os envolvidos, não
 * necessariamente o processo selecionado atualmente.
 */
export function getMensagemConfirmacao(tipo, ids = []) {
  // Comparator numérico explícito — achado em code review: a tela real usa
  // `ids.sort()[0]` sem comparator, que compara como STRING (ex.: `[2, 10]`
  // vira `[10, 2]`, já que `"10" < "2"` lexicograficamente). Diferente de
  // outras divergências desta etapa (que replicam a tela real de propósito),
  // aqui não há razão para portar o bug: a mensagem é só um texto de
  // confirmação, sem nenhum service dependendo do resultado deste `sort`.
  const oldIdProcesso = [...ids].sort((a, b) => Number(a) - Number(b))[0];
  if (tipo === 'JUNTAR') {
    return `Os Processos ${joinIds(ids)} serão juntados no Processo de nº ${oldIdProcesso}. Confirma esta operação?`;
  }
  if (tipo === 'UNIFICAR') {
    return `Os Processos ${joinIds(ids)} serão unificados no Processo de nº ${oldIdProcesso}. Confirma esta operação?`;
  }
  return '';
}
